export const arrayStatus = [
  {
    id: 16,
    name: 'nuevo',
    labelMain: 'Nuevo',
    labelVerb: 'Nuevo',
    classColorTxt: 'gray',
    next_status: 18,
    progress: 0,
    color: '#ADD8E6',
    arrayNextStatus: [18, 23],
  },
  {
    id: 17,
    name: 'planificar_pipa',
    labelMain: 'Planificar carga de pipa',
    labelVerb: 'Planificar carga de pipa',
    classColorTxt: 'darkGreen',
    next_status: 18,
    progress: 29,
    color: '#B2F2BB',
    arrayNextStatus: [18, 23],
  },
  {
    id: 18,
    name: 'carga_pipa',
    labelMain: 'Carga de pipa',
    labelVerb: 'Carga de pipa',
    classColorTxt: 'green',
    next_status: 19,
    progress: 39,
    color: '#1d9a8b',
    arrayNextStatus: [19, 23],
  },
  {
    id: 19,
    name: 'entrega_pipa',
    labelMain: 'Entrega de pipa',
    labelVerb: 'Entrega de pipa',
    classColorTxt: 'blue',
    next_status: 21,
    progress: 49,
    color: '#FFD8B1',
    arrayNextStatus: [21, 23],
  },
  /* {
    id: 20,
    name: 'comunicar_solucionado',
    labelMain: 'Comunicar solucionado',
    labelVerb: 'Comunicar solucionado',
    classColorTxt: 'darkPink',
    next_status: 21,
    progress: 69,
    color: '#D8BFD8',
    arrayNextStatus: [21, 23],
  }, */
  {
    id: 21,
    name: 'validacion',
    labelMain: 'Validación',
    labelVerb: 'Validación',
    classColorTxt: 'darkYellow',
    next_status: 22,
    progress: 89,
    color: '#FFCCCB',
    arrayNextStatus: [22, 23],
  },
  {
    id: 22,
    name: 'completado',
    labelMain: 'Completado',
    labelVerb: 'Completado',
    classColorTxt: 'yellow',
    next_status: null,
    progress: 100,
    color: '#73b971',
  },
  {
    id: 23,
    name: 'cancelado',
    labelMain: 'Cancelado',
    labelVerb: 'Cancelado',
    classColorTxt: 'darkRed',
    next_status: null,
    progress: 100,
    color: '#9a3f1d',
  },
  {
    id: 27,
    name: 'started',
  },
  {
    id: 28,
    name: 'extemporaneo',
    labelMain: 'Extemporáneo',
    labelVerb: 'Extemporáneo',
    classColorTxt: 'darkRed',
    next_status: null,
    progress: 100,
    color: '#9a3f1d',
  },
  {
    id: 36,
    name: 'En espera',
    labelMain: 'En espera',
    labelVerb: 'En espera',
    classColorTxt: 'darkRed',
    next_status: null,
    progress: 100,
    color: '#9a3f1d',
  },
]

export const fnObjNameStatus = () => {
  const obj = {}
  arrayStatus.forEach((item) => (obj[item.name] = item.id))
  return obj
}

export const findArrayStatus = (id) => {
  const findArray = arrayStatus.find((item) => item.id === parseInt(id))
  return findArray
}

export const fnArraySelectStatus = () => {
  const resp = arrayStatus.map((item) => ({
    value: item.id,
    label: item.labelMain,
  }))
  return resp
}

const objNameStatus = fnObjNameStatus()
const arrayAllStatusOptions = fnArraySelectStatus()

export const fnNextStatusArrayAllowed = (allowedArray) => {
  return arrayAllStatusOptions.filter((item) =>
    allowedArray.includes(item.value)
  )
}

export const fnStatusArrayCanSeeRole_globalManager = () => {
  const allowedStatus = [
    objNameStatus.pendiente,
    objNameStatus.validacion_final,
    objNameStatus.completado,
    objNameStatus.rechazar,
  ]

  return arrayAllStatusOptions.filter((item) =>
    allowedStatus.includes(item.value)
  )
}

export const fnStatusArrayCanSeeRole_internalManager = () => {
  const allowedStatus = [
    objNameStatus.planificar,
    objNameStatus.procesar,
    objNameStatus.asignar,
    objNameStatus.validacion_inicial,
    objNameStatus.validacion_final,
    objNameStatus.completado,
    objNameStatus.rechazar,
  ]

  return arrayAllStatusOptions.filter((item) =>
    allowedStatus.includes(item.value)
  )
}

export const fnStatusArrayCanSeeNewRequest = () => {
  const allowedStatus = [
    objNameStatus.nuevo,
    objNameStatus.planificar_pipa,
    objNameStatus.extemporaneo,
    objNameStatus['En espera'],
  ]
  return arrayAllStatusOptions.filter((item) =>
    allowedStatus.includes(item.value)
  )
}
